import axios from "axios";
import UserModel from '../../../models/UserModel';
import { urlBaseAccreditation } from './../../config/index';

export default async function getEventUsersApi(
  token = '',
  eventId = '',
) {
  try {
    const _config = {
      url: `${urlBaseAccreditation}/mobileUser/getMobileUsers`,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `bearer ${token}`
      },
      params: {
        eventId: eventId,
      },
    };

    const _data = await axios(_config);

    if (!_data.data.success) {
      throw new Error(_data.data.message);
    }

    const _return = [];
    const _users = _data.data.data;

    if (_users && _users.length > 0) {
      _users.forEach(item => {
        let _profileFields = getProfileFields(item.profile);

        _return.push(UserModel({
          ID: item.id,
          ContratoID: item.contractId,
          Login: item.login,
          Nome: item.name,
          Email: item.email,
          Perfil: _profileFields && _profileFields.profile ? _profileFields.profile : '',
          PerfilProgramacao: _profileFields && _profileFields.scheduleId ? _profileFields.scheduleId : '',
        }));
      });
    }

    return _return;

  } catch (error) {
    console.log('Error getEventUsersApi', error);
    throw error;
  }

  function getProfileFields(profileText) {
    let _return = null;
    try {
      if (profileText) {
        _return = JSON.parse(profileText);
      }
      return null;
    } catch (error) {
      console.log('Error getProfileFields', error);
      _return = null;
    } finally {
      return _return;
    }
  }
}
